'use es6';

import { fromJS } from 'immutable';
import { parseDynamicFilterFamilyId, testDynamicFilterFamily } from '../../../filterQueryFormat/DynamicFilterFamilies';
import { toDSFieldRecord } from 'customer-data-filters/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import always from 'transmute/always';
import createDSAdapter from 'customer-data-filters/components/fetcher/adapter/createDSAdapter';
import http from 'hub-http/clients/apiClient';
export const makeRecordMembershipAdapter = config => {
  const {
    getDataFromResponse,
    // network response -> array of objects
    getIdFromResponseObject,
    // response object -> id
    getLabelFromResponseObject,
    //response object -> label
    makeRequestUrl,
    // objetTypeId -> url
    makeRequestOptions,
    // _ -> request options
    supportedAssetFamily // dsAssetFamily to handle
  } = config;
  const dataCache = {};
  const requestCache = config.requestCache;
  const isAssetFamilySupported = assetFamily => {
    return testDynamicFilterFamily(supportedAssetFamily, assetFamily);
  };
  const fetch = (httpClient, _, assetFamily) => {
    if (dataCache[assetFamily]) {
      return Promise.resolve(dataCache[assetFamily]);
    }
    const objectTypeId = parseDynamicFilterFamilyId(supportedAssetFamily, assetFamily);
    const url = makeRequestUrl(objectTypeId);
    const request = requestCache && requestCache[url] || httpClient(url, makeRequestOptions ? makeRequestOptions() : {});
    if (requestCache && !requestCache[url]) {
      requestCache[url] = request;
    }
    return request.then(response => {
      const formattedResponse = {
        data: getDataFromResponse(response, objectTypeId),
        updateImmediate: true
      };
      dataCache[assetFamily] = formattedResponse;
      return formattedResponse;
    });
  };
  const updater = (result, prevData, assetFamily) => {
    if (!result || !result.data || !Array.isArray(result.data)) {
      return undefined;
    }
    const referenceRecords = result.data.map(responseObject => ReferenceRecord({
      id: getIdFromResponseObject(responseObject),
      label: getLabelFromResponseObject(responseObject),
      referencedObject: fromJS(responseObject)
    }));
    return toDSFieldRecord(referenceRecords, assetFamily);
  };
  return createDSAdapter({
    fetch,
    getFetcherFromProps: always(http.get),
    isAssetFamilySupported,
    updater
  });
};